<section
  class="trade-area"
  aria-label="Trade area"
  [class.trade-area--busy]="isAnalyzing()"
>
  <div class="trade-area__head">
    <span class="trade-area__label">Trade area</span>
    <app-feature-tooltip
      class="trade-area__hint"
      [tooltipText]="hint"
      featureName="Trade area"
      tooltipPosition="above"
      (openTooltipModal)="openHint($event)"
    ></app-feature-tooltip>
  </div>

  @if (mode === 'area') {
    <div class="trade-area__controls">
      @if (isAreaSearch) {
        <p class="trade-area__note">
          Search an address or click a spot to analyze the area around it
        </p>
      } @else {
        <p class="trade-area__note">
          A state or county is too large to start from
        </p>
        <button
          type="button"
          class="trade-area__link"
          data-cy="trade-area-pick-spot"
          (click)="pickSpot()"
        >
          Zoom in to pick a spot <span aria-hidden="true">→</span>
        </button>
      }
    </div>
  } @else {
    <div class="trade-area__controls">
      <label class="select">
        <select
          class="select__control"
          aria-label="Trade area size"
          data-cy="trade-area-shape"
          [disabled]="isAnalyzing()"
          (change)="onShapeChange($event)"
        >
          <optgroup label="Drive time">
            @for (minutes of drivePresets; track minutes) {
              <option
                [value]="shapeKey('drive', minutes)"
                [selected]="
                  shape().kind === 'drive' && shape().value === minutes
                "
              >
                {{ minutes }} min drive
              </option>
            }
          </optgroup>
          <optgroup label="Radius">
            @for (miles of radiusPresets; track miles) {
              <option
                [value]="shapeKey('radius', miles)"
                [selected]="
                  shape().kind === 'radius' && shape().value === miles
                "
              >
                {{ miles }} mi radius
              </option>
            }
          </optgroup>
        </select>
        <svg class="select__chevron" viewBox="0 0 14 8" aria-hidden="true">
          <path
            d="M7 5.48639L12.6953 0L14 1.2568L7 8L0 1.2568L1.30466 0L7 5.48639Z"
            fill="currentColor"
          />
        </svg>
      </label>

      <button
        type="button"
        class="trade-area__link"
        data-cy="trade-area-analyze"
        [class.is-loading]="isAnalyzing()"
        [disabled]="isAnalyzing() || isUnchanged()"
        [attr.aria-busy]="isAnalyzing()"
        (click)="analyze()"
      >
        @if (isAnalyzing()) {
          Analyzing…
        } @else {
          @if (accessService.isUnauthorized) {
            <svg appLockIcon class="trade-area__lock"></svg>
          }
          {{ mode === 'analyzed' ? 'Update' : 'Analyze' }}
          <span aria-hidden="true">→</span>
        }
      </button>

      @if (mode === 'analyzed') {
        <button
          type="button"
          class="trade-area__link trade-area__link--quiet"
          data-cy="trade-area-clear"
          (click)="clear()"
        >
          Clear
        </button>
      }
    </div>
  }
</section>
